import { render } from "./ReceivedAlerts.vue?vue&type=template&id=743bd951&scoped=true"
import script from "./ReceivedAlerts.vue?vue&type=script&lang=js"
export * from "./ReceivedAlerts.vue?vue&type=script&lang=js"

import "./ReceivedAlerts.vue?vue&type=style&index=0&id=743bd951&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743bd951"]])

export default __exports__